import { notification } from '@pu/mpp-ui/notifications';
import { BANNER_MAP_SPECIFIC_ERROR_CODE_LIST } from 'core/constants/banners.constants';
import type { TUpdateBannerParams } from 'core/model/interfaces/banners';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleSpecificErrors } from 'shared/utils/errors.utils';
import { getUnexpectedErrorMessage } from '../banners.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IBannersState } from '../types';

export const updateBanner = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/updateBanner`,
  async (params: { data: TUpdateBannerParams }, { rejectWithValue }) => {
    try {
      const { data } = params;

      await apiService.banners.updateBanner(data);

      notification.success('Banner actualizado correctamente.');
    } catch (error) {
      const handledError = handleSpecificErrors(error, getUnexpectedErrorMessage('drawer', 'update'), [
        ...BANNER_MAP_SPECIFIC_ERROR_CODE_LIST.keys(),
      ]);

      if (handledError) {
        return rejectWithValue(handledError);
      }

      throw error;
    }
  },
);

export const updateBannerReducer: TSliceExtraReducer<IBannersState> = builder =>
  builder
    .addCase(updateBanner.pending, state => {
      state.form.loading = true;
      state.form.success = false;
    })
    .addCase(updateBanner.rejected, state => {
      state.form.loading = false;
      state.form.success = false;
    })
    .addCase(updateBanner.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
    });
